var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStretchVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161085",
    "data-name": "Group 161085",
    transform: "translate(-6.897 -5.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161078",
    "data-name": "Group 161078",
    transform: "translate(6.897 5.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38817",
    "data-name": "Path 38817",
    d: "M.032.031,0,7.484,7.484,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148029",
    "data-name": "Rectangle 148029",
    width: 2.91,
    height: 7.038,
    transform: "translate(0.321 2.379) rotate(-45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161079",
    "data-name": "Group 161079",
    transform: "translate(6.897 14.729)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38817-2",
    "data-name": "Path 38817",
    d: "M.032,7.452,0,0,7.484,7.483Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148029-2",
    "data-name": "Rectangle 148029",
    width: 2.91,
    height: 7.038,
    transform: "translate(5.298 0.128) rotate(45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161080",
    "data-name": "Group 161080",
    transform: "translate(23.413 5.214)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38817-3",
    "data-name": "Path 38817",
    d: "M7.453.031l.032,7.452L0,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148029-3",
    "data-name": "Rectangle 148029",
    width: 2.91,
    height: 7.038,
    transform: "translate(2.186 7.355) rotate(-135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_161081",
    "data-name": "Group 161081",
    transform: "translate(23.413 14.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38817-4",
    "data-name": "Path 38817",
    d: "M7.453,7.452,7.484,0,0,7.483Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148029-4",
    "data-name": "Rectangle 148029",
    width: 2.91,
    height: 7.038,
    transform: "translate(7.163 5.105) rotate(135)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStretchVideo);
export default __webpack_public_path__ + "static/media/Stretch-Video.564f6798fac746e6f44baed101ceb122.svg";
export { ForwardRef as ReactComponent };